import { getTitle } from "@/utils/title";
import { LAYOUT_LADIES, LAYOUT_LADIES_V2 } from "@/utils/variables";

export default [
  {
    path: "/",
    component: () => import("@/pages/ladies-home/index.vue"),
    meta: {
      title: () => getTitle("Ersties"),
      layout: LAYOUT_LADIES_V2,
    },
  },
  {
    path: "/ladies",
    component: () => import("@/pages/ladies/index.vue"),
    meta: {
      title: () => getTitle("Ersties"),
      layout: LAYOUT_LADIES,
    },
  },
  {
    path: "/contact-us",
    component: () => import("@/pages/contact-us/index.vue"),
    meta: {
      title: () => getTitle("Contact Us"),
      layout: LAYOUT_LADIES_V2,
    },
  },
  {
    path: "/agb",
    component: () => import("@/pages/agb/index.vue"),
    meta: {
      title: () => getTitle("2257 Notice / Legal"),
      layout: LAYOUT_LADIES_V2,
    },
  },
  {
    path: "/report",
    component: () => import("@/pages/report/index.vue"),
    meta: {
      title: () => getTitle("Content Removal"),
      layout: LAYOUT_LADIES_V2,
    },
  },
  {
    path: "/dmca",
    component: () => import("@/pages/dmca/index.vue"),
    meta: {
      title: () => getTitle("DMCA"),
      layout: LAYOUT_LADIES_V2,
    },
  },
  {
    path: "/prohibited_content",
    component: () => import("@/pages/prohibited-content/index.vue"),
    meta: {
      title: () => getTitle("Prohibited Content"),
      layout: LAYOUT_LADIES_V2,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: { template: "404 Not Found" },
    meta: {
      title: () => getTitle("Not Found"),
      layout: LAYOUT_LADIES,
    },
  },
];
